import { type ReactNode } from 'react';

import { IonCol, IonHeader, IonRow, IonToolbar } from '@ionic/react';

import { useKeyboardShown } from '../../hooks/useKeyboardShown';

export const ChatHeader = ({
  forServiceProviders,
  topLeftContent,
  endButton,
  bottomContent,
}: {
  forServiceProviders: boolean;
  topLeftContent: ReactNode;
  endButton: ReactNode;
  bottomContent: ReactNode;
}) => {
  const keyboardShown = useKeyboardShown();
  const headerBg = forServiceProviders ? 'ts-blue-bg' : 'brand-ts-brown-bg';

  return (
    <IonHeader className="ion-no-border chat-header">
      <IonToolbar mode="ios" className={`ion-no-padding ${headerBg}`}>
        <IonRow
          className={`ion-justify-content-center ion-align-items-center chat-header-row ${
            keyboardShown ? 'keyboard-shown' : ''
          }`}
        >
          <IonCol className="ion-no-padding" sizeMd="6" sizeXl="4">
            <IonRow className="ion-align-items-center ion-justify-content-between ion-padding-horizontal ts-padding-top-1">
              <IonCol className="ion-no-padding">{topLeftContent}</IonCol>
              <IonCol className="ion-no-padding">
                <div className="report-end-chat-col">{endButton}</div>
              </IonCol>
            </IonRow>
            <IonRow className="ion-padding-horizontal ts-padding-bottom-1">{bottomContent}</IonRow>
          </IonCol>
        </IonRow>
      </IonToolbar>
    </IonHeader>
  );
};
